import { getStageLabel } from 'entities-next/stages'
import React, { useCallback } from 'react'
import { Select } from 'scenes/Dashboard/components/Inputs/Select'

import { PairingStageFilter, pairingStageFilters } from './PairingStageFilter.data'

export type PairingStageFilterSelectProps = {
  className?: string
  value: PairingStageFilter[]
  onChange: (finderStages: PairingStageFilter[]) => any
}

function getOptionValue(value: PairingStageFilter) {
  return value
}

export const PairingStageFilterSelect = React.memo(({ className, onChange, value }: PairingStageFilterSelectProps) => {
  const handleChange = useCallback(
    (stages: PairingStageFilter[] | '') => {
      onChange(stages === '' ? [] : stages)
    },
    [onChange]
  )
  return (
    <Select
      className={className}
      value={value}
      options={pairingStageFilters}
      getOptionLabel={getStageLabel}
      getOptionValue={getOptionValue}
      onChange={handleChange}
      isMulti
      placeholder="Pairing stage"
    />
  )
})

PairingStageFilterSelect.displayName = 'PairingStageFilterSelect'
